import * as React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import { GetUser } from '../../queries/user';
import CompactLayout from '../Layouts/CompactLayout';

type Props = {
  user: any;
};

const Settings: React.SFC<Props> = ({ user }) => (
  <CompactLayout>
    <p>Settings</p>
    {user && (
      <div>
        <p>userId: {user.userId}</p>
        <p>email: {user.email}</p>
        <p>phone: {user.phone}</p>
      </div>
    )}
  </CompactLayout>
);
export default compose(
  withApollo,
  graphql(GetUser, {
    props: (props: any) => ({
      user: props.data.user,
    }),
  }),
)(Settings);



// WEBPACK FOOTER //
// ./src/containers/Settings/Settings.tsx